"use client";

import { Flex, Spinner } from "@radix-ui/themes";
import dynamic from "next/dynamic";

export const ConsultationForm = dynamic(
  async () =>
    (await import("@/src/app/consultations/[slug]/ConsultationFormClient"))
      .ConsultationFormClient,
  {
    loading: () => (
      <Flex justify="center" p="9">
        <Spinner size="3" />
      </Flex>
    ),
    ssr: false,
  },
);
